module.exports = __webpack_public_path__ + "static/img/kv.f55261d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/index/kv.jpg
// module id = 7csd
// module chunks = 7